
import { connect } from "react-redux";
import { SASymbols } from "./SASymbols";
import { loadSymbols } from "../../superadmin/symbols-reducer";

const mapDispatchToProps = dispatch => {
  return {
    loadSymbols: () => { dispatch(loadSymbols()) },
  };
}

const mapStateToProps = state => {
  return {
    symbols: state.symbols,
    token: state.user.token,
    client: state.client,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SASymbols);
